module.exports = __webpack_public_path__ + "img/full_logo.9db44799.svg";